// R5-4 — THE SACRED TEXTS CATALOG, LIFTED OUT OF App.tsx VERBATIM.
//
// 368 lines of pure data with no JSX in it, which had no business sitting between a component and a
// component. The catalog itself is unchanged byte-for-byte; the `Book` type comes with it, because a
// type belongs beside the data it describes. `books` stays the one list the Library renders — it is a
// spread of this catalog and exists so a second source can be added without touching call sites.
//
// This is the CATALOG entry, not the library text. The real pages live in Postgres (`book_pages`,
// ingested by `server/ingest/books-pages.mjs`) and are served a page at a time by the reader.

export type Book = {
  title: string;
  category: string;
  type: "Book" | "Video";
  author?: string;
  sourceUrl?: string;
  pages: string[];
};

export const sacredTextBooks: Book[] = [
  {
    title: "The Pictorial Key to the Tarot",
    author: "A.E. Waite [1911]",
    category: "Tarot",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/tarot/index.htm",
    pages: ["The essential Tarot reference by the designer of the best known Tarot deck.", "This catalog entry is prepared for a protected 12th House reader import from Sacred Texts."],
  },
  {
    title: "The Tarot of the Bohemians",
    author: "Papus; translated by A. P Morton [1896]",
    category: "Tarot",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/tarot/index.htm",
    pages: ["A detailed study of the esoteric roots of the Tarot.", "Future import can preserve the source and open chapters inside the subscriber reader."],
  },
  {
    title: "The Tarot",
    author: "S.L. MacGregor Mathers [1888]",
    category: "Tarot",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/tarot/index.htm",
    pages: ["A short essay on the Tarot by a prominent occultist of the 19th century.", "Cataloged for Tarot study, correspondence work, and future search indexing."],
  },
  {
    title: "The Symbolism of the Tarot",
    author: "P. D. Ouspensky [1913]",
    category: "Tarot",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/tarot/index.htm",
    pages: ["An evocative inner journey through the Major Arcana of the Tarot.", "This source belongs on the Tarot shelf for symbolic and contemplative study."],
  },
  {
    title: "General Book of the Tarot",
    author: "A.E. Thierens [1930]",
    category: "Tarot",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/tarot/index.htm",
    pages: ["A system of correspondences between Tarot and Astrology.", "This is useful for the bridge between Tarot, astrology, timing, and symbolic reading."],
  },
  {
    title: "Fortune-Telling by Cards",
    author: "P.R.S. Foli [1915]",
    category: "Tarot",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/tarot/index.htm",
    pages: ["Several methods of telling fortunes with a standard deck of playing cards.", "Prepared for card-reading study inside the protected library."],
  },
  {
    title: "The Migration of Symbols",
    author: "Goblet d'Alviella [1894]",
    category: "Symbols",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/sym/index.htm",
    pages: ["A study of the migration and mutation of powerful archaic symbols.", "This source supports symbolic literacy across dreams, seals, ritual, and sacred art."],
  },
  {
    title: "The Book of Talismans, Amulets and Zodiacal Gems",
    author: "William Thomas Pavitt and Kate Pavitt [1914]",
    category: "Symbols",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/sym/index.htm",
    pages: ["A study of the symbolism of gems and their astrological signatures.", "This belongs with seal creation, talismanic study, and zodiacal correspondences."],
  },
  {
    title: "Architecture, Mysticism and Myth",
    author: "W.R. Lethaby [1892]",
    category: "Symbols",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/sym/index.htm",
    pages: ["A work on the macrocosm reflected in ancient architecture.", "Cataloged for sacred structure, temple symbolism, and mythic design study."],
  },
  {
    title: "Fictitious and Symbolic Creatures in Art",
    author: "John Vinycomb [1909]",
    category: "Symbols",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/sym/index.htm",
    pages: ["Lore of symbolic creatures in English heraldry and visual art.", "Useful for symbolic image reading, dream images, and esoteric visual language."],
  },
  {
    title: "The Signature of All Things",
    author: "Jacob Boehme, translated by Anonymous [1912]",
    category: "Symbols",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/sym/index.htm",
    pages: ["A Christian mystic explains hidden meanings implicit in everything.", "This entry is prepared for future mystical-symbolic study paths."],
  },
  {
    title: "The Secret Teachings of All Ages",
    author: "Manley Palmer Hall [1928]",
    category: "Symbols",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/sym/index.htm",
    pages: ["A broad introduction to esoteric traditions including Qaballa, Tarot, ceremonial magic, mystery religions, Rosicrucianism, and Freemasonry.", "This source is cataloged for advanced esoteric study inside the library."],
  },
  {
    title: "The Gnostics and Their Remains",
    author: "Charles William King [1887]",
    category: "Symbols",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/sym/index.htm",
    pages: ["A historical summary of Gnostic symbols and beliefs as understood before the Nag Hammadi discoveries.", "Prepared for symbolic, Gnostic, and initiatory history study."],
  },
  {
    title: "The Hieroglyphics of Horapollo",
    author: "translated by Alexander Turner Cory [1840]",
    category: "Symbols",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/sym/index.htm",
    pages: ["A late antique attempt to explain Egyptian hieroglyphs as pure symbols.", "Cataloged for Egyptian symbolism, occult history, and symbolic interpretation."],
  },
  {
    title: "Kama Sutra of Vatsayayana",
    author: "translated by Sir Richard Burton [1883]",
    category: "Sacred Sexuality",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/sex/index.htm",
    pages: ["A classic Indian text on love, culture, sexuality, and social life.", "This source should be handled with age-appropriate subscriber boundaries in a future build."],
  },
  {
    title: "The Ananga Ranga",
    author: "translated by Sir Richard Burton [1885]",
    category: "Sacred Sexuality",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/sex/index.htm",
    pages: ["An important work of Indian erotology from the sixteenth century.", "Cataloged for historical study with careful member access boundaries."],
  },
  {
    title: "The Perfumed Garden",
    author: "Shaykh Umar ibn Muhammed al-Nefzawi; translated by Sir Richard Burton [1886]",
    category: "Sacred Sexuality",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/sex/index.htm",
    pages: ["A well-known Islamic work on erotology and relationship knowledge.", "Cataloged as historical sacred-sexuality material for future protected reading."],
  },
  {
    title: "The Holy Piby",
    author: "Robert Athlyi Rogers [1924]",
    category: "African Diaspora",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/afr/index.htm",
    pages: ["A foundational Afrocentric religious text associated with early Rastafarian thought.", "Prepared for the African and diaspora shelf in the library."],
  },
  {
    title: "Oahspe, A Kosmon Bible in the Words of Jehovih",
    author: "John Ballou Newbrough [1882]",
    category: "African Diaspora",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/afr/index.htm",
    pages: ["Listed by Sacred Texts under African and diaspora resources.", "Cataloged for future source review before full import."],
  },
  {
    title: "The Royal Parchment Scroll of Black Supremacy",
    author: "Fitz Balintine Pettersburg [1926]",
    category: "African Diaspora",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/afr/index.htm",
    pages: ["A Black Supremacy/Rastafarian source text listed in Sacred Texts.", "Prepared for historical study in the protected library."],
  },
  {
    title: "The Promised Key",
    author: "G. G. Maragh [1935]",
    category: "African Diaspora",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/afr/index.htm",
    pages: ["A key early Rastafarian source text.", "Cataloged for African diaspora religion and spiritual history."],
  },
  {
    title: "The Wisdom of Rastafari",
    author: "Haile Selassie and others [1996]",
    category: "African Diaspora",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/afr/index.htm",
    pages: ["A collection of Rastafari wisdom and source material.", "Prepared for subscriber reading once the library importer is live."],
  },
  {
    title: "The Sayings of the Wise",
    author: "W. A. Clouston [1885]",
    category: "African Diaspora",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/afr/index.htm",
    pages: ["A collection listed on the African index page.", "Cataloged for proverb and wisdom-literature study."],
  },
  {
    title: "Folk Stories from Southern Nigeria",
    author: "Elphinstone Dayrell [1910]",
    category: "African Diaspora",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/afr/index.htm",
    pages: ["A collection of Southern Nigerian folk stories.", "Prepared for myth, ancestor, story, and cultural study."],
  },
  {
    title: "Woman's Mysteries of a Primitive People",
    author: "D. Amaury Talbot [1915]",
    category: "African Diaspora",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/afr/index.htm",
    pages: ["A historical ethnographic text listed in the African collection.", "This source should be framed carefully with historical context in future imports."],
  },
  {
    title: "At the Back of the Black Man's Mind",
    author: "R. E. Dennett [1906]",
    category: "African Diaspora",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/afr/index.htm",
    pages: ["A historical text listed in Sacred Texts' African resources.", "Prepared for careful contextual review before deeper reader import."],
  },
  {
    title: "The Negro",
    author: "W.E.B. Du Bois [1915]",
    category: "African Diaspora",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/afr/index.htm",
    pages: ["A historical work by W.E.B. Du Bois.", "Cataloged for African history and diaspora study."],
  },
  {
    title: "South African Folk-Tales",
    author: "James A. Honey [1910]",
    category: "African Diaspora",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/afr/index.htm",
    pages: ["A collection of South African folk tales.", "Prepared for mythic and ancestral story study."],
  },
  {
    title: "Specimens of Bushman Folklore",
    author: "W.H.I. Bleek and L.C. Lloyd [1911]",
    category: "African Diaspora",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/afr/index.htm",
    pages: ["A major collection of Bushman folklore.", "Cataloged for African folklore, myth, and oral tradition study."],
  },
  {
    title: "The Book of the Cave of Treasures",
    author: "E. A. Wallis Budge [1927]",
    category: "African Diaspora",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/afr/index.htm",
    pages: ["A legendary history text listed in the African collection.", "Prepared for future protected reading and source indexing."],
  },
  {
    title: "The Laughable Stories of Bar-Hebraeus",
    author: "E. A. Wallis Budge [1897]",
    category: "African Diaspora",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/afr/index.htm",
    pages: ["A collection translated by E. A. Wallis Budge.", "Cataloged for historical and comparative wisdom literature."],
  },
  {
    title: "Ancient Fragments",
    author: "I. P. Cory [1832]",
    category: "Alchemy",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/alc/index.htm",
    pages: ["A source listed in the alchemy collection.", "Prepared for alchemical and ancient-fragment study."],
  },
  {
    title: "The Golden Tractate of Hermes Trismegistus",
    author: "translated by A. E. Waite [1893]",
    category: "Alchemy",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/alc/index.htm",
    pages: ["A Hermetic alchemical text.", "Cataloged for alchemy, Hermeticism, and transformation symbolism."],
  },
  {
    title: "The Hermetic Museum",
    author: "A. E. Waite [1893]",
    category: "Alchemy",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/alc/index.htm",
    pages: ["A large collection of alchemical writings.", "Prepared for alchemical study and future searchable import."],
  },
  {
    title: "The Turba Philosophorum",
    author: "Arthur Edward Waite [1896]",
    category: "Alchemy",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/alc/index.htm",
    pages: ["A classic alchemical dialogue text.", "Cataloged for transformation, Hermetic philosophy, and symbolic study."],
  },
  {
    title: "The Book of Aquarius",
    category: "Alchemy",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/alc/index.htm",
    pages: ["An alchemy title listed on Sacred Texts.", "Prepared for future source review before import."],
  },
  {
    title: "Tetrabiblos",
    author: "Ptolemy; translated by J. M. Ashmand [1822]",
    category: "Astrology",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/astro/index.htm",
    pages: ["A foundational Western astrology text.", "Prepared for astrology source study inside the 12th House library."],
  },
  {
    title: "Christian Astrology",
    author: "William Lilly [1647]",
    category: "Astrology",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/astro/index.htm",
    pages: ["A major traditional astrology manual.", "Cataloged for horary, timing, and traditional astrology study."],
  },
  {
    title: "Astrology and Religion Among the Greeks and Romans",
    author: "Franz Cumont [1912]",
    category: "Astrology",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/astro/index.htm",
    pages: ["A historical study of astrology and religion in the ancient Mediterranean.", "Prepared for astrological history and spiritual context."],
  },
  {
    title: "From the Closed World to the Infinite Universe",
    author: "Alexandre Koyre [1957]",
    category: "Astrology",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/astro/index.htm",
    pages: ["A history of cosmological thought listed in the astrology collection.", "Cataloged for cosmology and worldview study."],
  },
  {
    title: "The Egyptian Book of the Dead",
    author: "E. A. Wallis Budge [1895]",
    category: "Egyptian",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/egy/index.htm",
    pages: ["A major funerary and spiritual text from ancient Egypt in Budge's translation.", "Prepared for Egyptian spirituality, afterlife symbolism, and ritual study."],
  },
  {
    title: "The Book of Gates",
    category: "Egyptian",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/egy/index.htm",
    pages: ["An Egyptian underworld text listed in the Egyptian collection.", "Cataloged for underworld, passage, and initiatory symbolism."],
  },
  {
    title: "The Book of Am-Tuat",
    category: "Egyptian",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/egy/index.htm",
    pages: ["An ancient Egyptian underworld text.", "Prepared for Egyptian cosmology and symbolic journey study."],
  },
  {
    title: "Legends of the Gods",
    author: "E. A. Wallis Budge [1912]",
    category: "Egyptian",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/egy/index.htm",
    pages: ["Egyptian mythological and religious legends.", "Cataloged for deity, myth, and sacred story study."],
  },
  {
    title: "The Liturgy of Funerary Offerings",
    author: "E. A. Wallis Budge [1909]",
    category: "Egyptian",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/egy/index.htm",
    pages: ["A translation of Egyptian funerary offering liturgies.", "Prepared for ritual, ancestor, and offering-study context."],
  },
  {
    title: "The Burden of Isis",
    author: "James Teackle Dennis [1910]",
    category: "Egyptian",
    type: "Book",
    sourceUrl: "https://sacred-texts.com/egy/index.htm",
    pages: ["An Egyptian-themed sacred and poetic work listed in the collection.", "Cataloged for Egyptian devotional and symbolic study."],
  },
];

export const books: Book[] = [
  ...sacredTextBooks,
];
